import apiClient from './apiClient'

export const AVITO_ACCOUNT_STATUSES = Object.freeze(['active', 'disabled'])

export function validateAvitoAccountInput({ name, status }) {
	const normalizedName = typeof name === 'string' ? name.trim() : ''
	const errors = {}

	if (!normalizedName) {
		errors.name = 'Укажите название аккаунта.'
	} else if (normalizedName.length > 100) {
		errors.name = 'Название не должно быть длиннее 100 символов.'
	}
	if (!AVITO_ACCOUNT_STATUSES.includes(status)) {
		errors.status = 'Выберите допустимый статус.'
	}

	return {
		valid: Object.keys(errors).length === 0,
		errors,
		payload: { name: normalizedName, status },
	}
}

export function getAvitoAccountErrorMessage(error) {
	const code = error?.response?.data?.error?.code
	if (code === 'ACCOUNT_NAME_CONFLICT') {
		return 'Аккаунт с таким названием уже существует.'
	}
	if (code === 'ACCOUNT_IN_USE') {
		return 'Аккаунт используется объявлениями и не может быть удалён.'
	}
	if (code === 'ACCOUNT_NOT_FOUND') {
		return 'Аккаунт не найден или недоступен.'
	}
	if (code === 'ACCOUNT_INPUT_INVALID') {
		return error.response.data.error.message || 'Проверьте заполненные поля.'
	}
	return 'Не удалось выполнить операцию с аккаунтом Авито.'
}

export async function listAvitoAccounts(client = apiClient) {
	const response = await client.get('/classifieds/avito/accounts')
	return Array.isArray(response.data?.accounts) ? response.data.accounts : []
}

export async function createAvitoAccount(payload, client = apiClient) {
	const response = await client.post('/classifieds/avito/accounts', payload)
	return response.data.account
}

export async function updateAvitoAccount(accountId, payload, client = apiClient) {
	const response = await client.patch(
		`/classifieds/avito/accounts/${accountId}`,
		payload
	)
	return response.data.account
}

export async function deleteAvitoAccount(accountId, client = apiClient) {
	await client.delete(`/classifieds/avito/accounts/${accountId}`)
}
